// Photo upload plugins need this stuff to be able to upload to s3 and load existing photos

export const photoUploadMix = {
  props: {
    endpoint: {
      type: String,
      required: false,
    },
    accessKey: {
      type: String,
      required: false,
    },
    cloudfrontBaseUrl: {
      type: String,
      required: false,
    },
    existingAttachments: {
      type: Array,
      default() { return []; },
    },
  },
  data() {
    return {
      photoAttachments: [],
    };
  },
  created() {
    // loop through existingAttachments prop and set the photoAttachmentParams
    this.existingAttachments.forEach((attachment) => {
      this.photoAttachments.push({
        id: attachment.id,
        key: attachment.key,
        name: attachment.name,
        url: attachment.url,
        status: 'uploaded',
        _destroy: false,
      });
    });
  },
  computed: {
    attachmentParams() {
      // Remove all the front end stuff we use to manage the photos
      return _.flatMap(this.photoAttachments, (attachment) => ({
        id: attachment.id,
        _destroy: attachment._destroy,
      }));
    },
    hasOneAttachmentParams() {
      let attachment = this.photoAttachments.find((attachment) => attachment.status === 'uploaded' && !attachment._destroy);

      if (!attachment) {
        attachment = this.photoAttachments[0];
      }

      if (!attachment) {
        return {};
      }

      return {
        id: attachment.id,
        _destroy: attachment._destroy,
      };
    },
    hasUploadedPhoto() {
      return this.photoAttachments.some((attachment) => attachment.status === 'uploaded' && !attachment._destroy);
    },
    // True while any picked photo is still on its way to S3. Saving now would
    // silently drop the photo — hosts should gate their save on this.
    photoUploadInFlight() {
      return this.photoAttachments.some((attachment) => attachment.status === 'upload_pending' && !attachment._destroy);
    },
  },
  methods: {
    photosChanged(photos) {
      // Alright so at this point photos have attachment_ids if the exist and destroy is updating appropriately (I think).
      // so we need to update our local copy of attachments to reflect this.
      // We need to add new attachments, update existing attachments, particularly the _destroy flag
      // A revert (user cancels an upload) splices the photo out of the
      // uploader's array entirely; drop the matching pending entry here or it
      // reads as in-flight forever. Only pending entries — 'uploaded' ones
      // can also come from the existingAttachments prop.
      const incomingKeys = photos.map((photo) => photo.s3_file_name);
      _.remove(this.photoAttachments, (attachment) => attachment.status === 'upload_pending' && !incomingKeys.includes(attachment.key));
      photos.forEach((photo) => {
        const existingAttachments = this.photoAttachments.filter((attachment) => attachment.id === photo.id || attachment.key === photo.s3_file_name);
        if (existingAttachments.length > 0) {
          existingAttachments.forEach((existingAttachment) => {
            existingAttachment._destroy = photo._destroy;
            // The same photo reports upload_pending first and uploaded on
            // confirm — without this the entry stays pending forever
            existingAttachment.status = photo.status;
          });
        } else {
          this.photoAttachments.push({
            id: photo.id,
            key: photo.s3_file_name,
            name: photo.file_name,
            url: photo.url,
            status: photo.status,
            _destroy: photo._destroy,
          });
        }
      });
      // The uploader's order is the display order (drag to reorder), and
      // attachmentParams is sent in this order, so keep the two in sync
      const orderOf = (attachment) => photos.findIndex(
        (photo) => attachment.id === photo.id || attachment.key === photo.s3_file_name,
      );
      this.photoAttachments = _.sortBy(this.photoAttachments, (attachment) => {
        const index = orderOf(attachment);
        return index === -1 ? Number.MAX_SAFE_INTEGER : index;
      });
    },
  },
};
